import React from 'react';
import './AddToHomeScreenModal.css';

/**
 * Modal with platform-specific instructions for adding the app to home screen.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {'wechat' | 'ios-safari' | 'android-chrome' | 'desktop'} props.platform
 */
function AddToHomeScreenModal({ isOpen, onClose, platform }) {
  if (!isOpen) return null;

  function handleOverlayClick(e) {
    if (e.target === e.currentTarget) onClose();
  }

  return (
    <div className="a2hs-overlay" onClick={handleOverlayClick}>
      <div className="a2hs-content">
        <div className="a2hs-header">
          <h2>添加到主屏幕</h2>
          <button className="a2hs-close" onClick={onClose} aria-label="关闭">
            &times;
          </button>
        </div>
        <div className="a2hs-body">
          {platform === 'wechat' && <WeChatInstructions />}
          {platform === 'ios-safari' && <IOSInstructions />}
          {platform === 'desktop' && <DesktopInstructions />}
        </div>
        <div className="a2hs-footer">
          <button className="a2hs-btn-ok" onClick={onClose}>
            知道了
          </button>
        </div>
      </div>
    </div>
  );
}

function WeChatInstructions() {
  return (
    <>
      <div className="a2hs-icon" role="img" aria-label="browser">🌐</div>
      <p className="a2hs-message">请先在浏览器中打开</p>
      <div className="a2hs-steps">
        <div className="a2hs-step">
          <span className="a2hs-step-num">①</span>
          <span>点击右上角 <strong>···</strong> 按钮</span>
          <div className="a2hs-arrow-topright" role="img" aria-label="arrow">↗️</div>
        </div>
        <div className="a2hs-step">
          <span className="a2hs-step-num">②</span>
          <span>选择「<strong>在浏览器中打开</strong>」</span>
        </div>
        <div className="a2hs-step">
          <span className="a2hs-step-num">③</span>
          <span>然后回到设置页面再次点击</span>
        </div>
      </div>
    </>
  );
}

function IOSInstructions() {
  return (
    <>
      <div className="a2hs-icon" role="img" aria-label="phone">📱</div>
      <p className="a2hs-message">将小羊英语添加到主屏幕</p>
      <div className="a2hs-steps">
        <div className="a2hs-step">
          <span className="a2hs-step-num">①</span>
          <span>点击底部 <strong>⎋ 分享</strong> 按钮</span>
        </div>
        <div className="a2hs-step">
          <span className="a2hs-step-num">②</span>
          <span>向下滑动，点击「<strong>添加到主屏幕</strong>」</span>
        </div>
        <div className="a2hs-step">
          <span className="a2hs-step-num">③</span>
          <span>点击右上角「<strong>添加</strong>」</span>
        </div>
      </div>
    </>
  );
}

function DesktopInstructions() {
  return (
    <>
      <div className="a2hs-icon" role="img" aria-label="computer">💻</div>
      <p className="a2hs-message">此功能仅支持手机浏览器</p>
      <p className="a2hs-submessage">请在手机上打开本页面，然后添加到主屏幕</p>
    </>
  );
}

export default AddToHomeScreenModal;
